import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { ThemeService } from '../../../shared/services/theme.service'

@Component({
  selector: 'app-rb-live-clip',
  templateUrl: './rb-live-clip.component.html',
  styleUrls: ['./rb-live-clip.component.scss'],
  standalone: false,
})
export class RbLiveClipComponent implements OnInit, OnDestroy {
  logoSrc = 'assets/images/Bosch_symbol_logo_black.svg'
  private readonly destroy$ = new Subject<void>()

  constructor(private readonly themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService
      .getTheme$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((theme) => {
        this.logoSrc =
          theme === 'dark'
            ? 'assets/images/Bosch_symbol_logo_white.svg'
            : 'assets/images/Bosch_symbol_logo_black.svg'
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
